import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BouncingArrowsDirection = 'up' | 'down' | 'left' | 'right';
export type BouncingArrowsColor = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning' | 'danger' | 'light' | 'medium' | 'dark';
export type BouncingArrowsSpeed = 'slow' | 'fast';

@Component({
  selector: 'lib-bouncing-arrows',
  imports: [],
  templateUrl: './bouncing-arrows.html',
  styleUrl: './bouncing-arrows.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-direction]': 'direction()',
    '[attr.data-speed]': 'speed()',
    '[style.--arrow-color]': 'colorVar()',
  },
})
export class BouncingArrows {
  public readonly direction = input<BouncingArrowsDirection>('down');
  public readonly color = input<BouncingArrowsColor>('primary');
  public readonly speed = input<BouncingArrowsSpeed>('slow');

  protected readonly colorVar = computed(() => `var(--color-${this.color()})`);
}
